import React, { useState, useEffect } from 'react';
import { Outlet } from 'react-router-dom';
import { FaBars } from 'react-icons/fa';
import AdminDrawer from './AdminDrawer';
import './AdminLayout.scss';

/**
 * Admin Layout Component
 * Provides consistent layout for all admin pages with side drawer navigation
 */
const AdminLayout: React.FC = () => {
  const [isDrawerOpen, setIsDrawerOpen] = useState(false);

  // Hide the global footer while any admin page is mounted
  useEffect(() => {
    document.body.classList.add('admin-mode');
    return () => document.body.classList.remove('admin-mode');
  }, []);

  return (
    <div className="admin-layout">
      {/* Mobile Menu Button */}
      <button
        className="admin-mobile-menu-btn"
        onClick={() => setIsDrawerOpen(true)}
        aria-label="Open admin menu"
      >
        <FaBars />
        <span>Admin Menu</span>
      </button>

      {/* Side Drawer */}
      <AdminDrawer isOpen={isDrawerOpen} onClose={() => setIsDrawerOpen(false)} />

      {/* Main Content Area */}
      <div className="admin-content">
        <Outlet />
      </div>
    </div>
  );
};

export default AdminLayout;
